/**
 * Created by pajicv on 10/4/18.
 */
import React from 'react';
import { IconButton, TextField, withStyles, Typography, InputAdornment } from '@material-ui/core';
import ToggleOn from '@material-ui/icons/ToggleOn';
import ToggleOff from '@material-ui/icons/ToggleOff';
import DeleteIcon from '@material-ui/icons/Delete';
import { updateTaskName, updateTaskActive } from '../../firebase/db';
import { getSubTasks, getTaskData } from '../../firebase/db/tasks';
import { db } from '../../firebase/firebase';
import { FIREBASE_PROJECT_ID } from '../../firebase-config';

const styles = theme => ({
  taskButtonEnabled: {
    width: '100%',
    height: 60,
    borderRadius: 10,
    backgroundColor: '#fff',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#ccc',
    opacity: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '1px 1px 1px 1px #ccc'
  },
  taskButtonDisabled: {
    width: '100%',
    height: 60,
    borderRadius: 10,
    backgroundColor: '#ddd',
    opacity: 0.3,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  textField: {
    '&$disabled': {
      color: 'white',
    }
  },
  textFieldDisabled: {},
  coloredPart: {
    width: '10%',
    height: 60,
    borderRadius: '10px 0px 0px 10px'
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '80%'
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    width: '10%'
  }
});

class TaskButton extends React.Component {
  timer = 0;

  delay = 200;

  prevent = false;

  constructor(props) {
    super(props);
    this.state = {
      textFieldDisabled: true,
      taskButtonDisabled: false,
      name: '',
      subTasks: {},
      placeholder: "enter task name",
      isEditButtonVisible: false
    };
  }

  handleClick = () => {
    const me = this;
    me.timer = setTimeout(() => {
      if (!me.prevent) {
        if (!me.state.taskButtonDisabled) {
          me.props.onTaskClick(me.props.id);
        }
      }
      me.prevent = false;
    }, me.delay);
  };

  handleDoubleClick = () => {
    const { id } = this.props;
    const { name, textFieldDisabled } = this.state;
    clearTimeout(this.timer);
    this.prevent = true;
    if (textFieldDisabled) {
      this.setState({ textFieldDisabled: false, placeholder: '' }, () => this.nameInputField.focus());
    } else {
      updateTaskName(id, name)
        .then(() => this.setState({ textFieldDisabled: true, placeholder: "enter task name" }));
    }
  };

  handleNameBlur = (e) => {
    const { id } = this.props;
    const { name } = this.state;
    updateTaskName(id, name)
      .then(() => this.setState({ textFieldDisabled: true, placeholder: "enter task name" }));
  };

  handleToggle = (e) => {
    const { id, onActiveTaskToggle } = this.props;
    const { taskButtonDisabled } = this.state;
    const wasActive = !taskButtonDisabled;
    updateTaskActive(id, !wasActive)
      .then(() => {
        this.setState(state => ({ taskButtonDisabled: !state.taskButtonDisabled }));
        onActiveTaskToggle(id, !wasActive);
      });
    e.stopPropagation();
  };

  handleTaskRemoveClick = (e) => {
    const { id, onTaskRemove } = this.props;
    const { name } = this.state;
    onTaskRemove(id, name);
    e.stopPropagation();
  };

  handleNameChange = (e) => {
    this.setState({ name: e.target.value });
  };

  shouldComponentUpdate(prevProps, prevState) {
    const { name, taskButtonDisabled, textFieldDisabled, placeholder, subTasks, isEditButtonVisible } = this.state;
    if (prevState.name !== name || prevState.taskButtonDisabled !== taskButtonDisabled || prevState.textFieldDisabled !== textFieldDisabled
      || prevState.placeholder !== placeholder || prevState.subTasks !== subTasks || prevState.isEditButtonVisible !== isEditButtonVisible) {
      return true;
    }
    return false;
  }

  calculateColor = () => {
    const { subTasks } = this.state;
    const isAssignedTo = Object.keys(subTasks).findIndex((subTaskId) => subTasks[subTaskId].assignedTo) > -1;
    if (isAssignedTo) {
      const isStarted = Object.keys(subTasks).reduce((result, subTaskId) => {
        return result || subTasks[subTaskId].finished;
      }, false);
      const isFinished = Object.keys(subTasks).reduce((result, subTaskId) => {
        return result && subTasks[subTaskId].finished;
      }, true);
      if (isFinished) {
        return '#0f0';
      } else if (!isStarted) {
        return '#ff0';
      }
      //started but not finished
      return '#f80';
    }
    return '#ddd';
  };

  calculateDueDate = () => {
    const { id, onDueDateChange } = this.props;
    const { subTasks, name } = this.state;
    const dueDate = Object.keys(subTasks || {})
      .map(subTaskId => subTasks[subTaskId].endDate)
      .filter(endDate => endDate)
      .sort((dueDate1, dueDate2) => (new Date(dueDate1)).getTime() - (new Date(dueDate2)).getTime())
      .pop();

    if (dueDate) {
      onDueDateChange(id, dueDate);
    }

    return dueDate;
  };

  componentDidMount() {
    const { id } = this.props;
    getTaskData(id)
      .then(task => getSubTasks(id)
        .then(subTasks => this.setState({ name: task.name, taskButtonDisabled: !task.active, subTasks })));
    db.ref('subTasks').orderByChild('task').equalTo(id).on('child_added', () => {
      getSubTasks(id)
        .then(subTasks => this.setState({ subTasks }));
    });
    db.ref('subTasks').orderByChild('task').equalTo(id).on('child_removed', () => {
      getSubTasks(id)
        .then(subTasks => this.setState({ subTasks }));
    });
    db.ref('subTasks').orderByChild('task').equalTo(id).on('child_changed', () => {
      getSubTasks(id)
        .then(subTasks => this.setState({ subTasks }));
    });
  }

  componentDidUpdate(prevProps) {
    console.log("CDU" + id);
    const { id, subTaskAssigned } = this.props;
    if (prevProps.subTaskAssigned !== subTaskAssigned) {
      getTaskData(id)
        .then(task => getSubTasks(id)
          .then(subTasks => this.setState({ name: task.name, taskButtonDisabled: !task.active, subTasks })));
    }
  }

  handleMouseOverTitle = (e) => { console.log('enter'); this.setState({ isEditButtonVisible: true }); }

  handleMouseOutTitle = (e) => { console.log('exit'); this.setState({ isEditButtonVisible: false }); }

  render() {
    const { classes, id } = this.props;
    const backgroundColor = this.calculateColor();
    const dueDate = this.calculateDueDate();
    const { name, isEditButtonVisible } = this.state;
    const { textFieldDisabled, taskButtonDisabled } = this.state;
    return (
      <React.Fragment>
        <div
          className={taskButtonDisabled ? classes.taskButtonDisabled : classes.taskButtonEnabled}
          //onDoubleClick={this.handleDoubleClick}
          onClick={this.handleClick}
        >
          <div className={classes.coloredPart} style={{ backgroundColor }}></div>
          <div className={classes.leftContainer}>
            <div style={{ width: '100%', textAlign: 'left' }} onMouseOver={this.handleMouseOverTitle} onMouseLeave={this.handleMouseOutTitle}>
              <TextField
                inputRef={(inputField) => { this.nameInputField = inputField; }}
                inputProps={{ style: { textAlign: 'left', fontSize: 16, color: '#000', fontFamily: "'Roboto', sans-serif" } }}
                placeholder={this.state.placeholder}
                // eslint-disable-next-line
                InputProps={{
                  disableUnderline: true, endAdornment: isEditButtonVisible && <InputAdornment position="end">
                    <img src={require('../../icons/edit.svg')} height="20" width="20" alt="Delete task" onClick={this.handleDoubleClick} style={{ position: 'relative', right: 20 }} />
                  </InputAdornment>
                }}
                underlineStyle={{ display: 'none' }}
                margin="none"
                value={name}
                onChange={this.handleNameChange}
                onBlur={e => this.handleNameBlur(e)}
                disabled={textFieldDisabled}
              />
            </div>
            <Typography style={{ color: dueDate ? '#000' : '#fff', fontSize: 14 }}>{dueDate || 'n/a'}</Typography>
          </div>
          <div className={classes.rightContainer}>
            <div
              aria-label="Enable / Disable"
              onClick={this.handleToggle}
              style={{ height: 30 }}
            >
              {taskButtonDisabled ? <ToggleOn /> : <ToggleOff />}
            </div>
            <div
              onClick={this.handleTaskRemoveClick}
              style={{ height: 30 }}
            >
              <img src={FIREBASE_PROJECT_ID === 'uxs-autumn' ? require('../../icons/trash-red.svg') : require('../../icons/trash-blue.svg')} height="20" width="20" alt="Delete task" />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(TaskButton);



// WEBPACK FOOTER //
// ./src/components/common/TaskButton.js